//
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "datav",
  data: function data() {
    return {
      reload: true,
      config: {}
    };
  },
  methods: {
    updateChart: function updateChart() {
      var _this = this;

      var optionData = this.deepClone(this.dataChart) || [];
      this.config = this.echartFormatter(optionData);
      console.log('enter', this.config);
      this.reload = false;
      this.$nextTick(function () {
        _this.reload = true;
      });
    }
  }
});